import { t } from '@lingui/macro'
import DOMPurify from 'dompurify'
import { isEmpty } from 'ramda'
import { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { StNotes } from './EncounterNotes.styled'

import type { Encounter } from '../../types/encounter.types'

type Props = {
  encounter?: Encounter
}

const EncounterNotes = ({ encounter }: Props) => {
  const theme = useTheme()
  const notes = encounter?.meta?.notes

  return notes && !isEmpty(notes) ? (
    <FlexColumn gap={theme.UI.Spacing.Space3}>
      <Span type='BodyMediumBold'>
        {t({
          id: 'encounters.detail.about',
          message: 'Over deze opname',
        })}
      </Span>
      {encounter?.meta?.notes?.map((note, index) => (
        <StNotes key={index} type='BodyMediumRegular'>
          <div
            // biome-ignore lint/security/noDangerouslySetInnerHtml: sanitized with DOMPurify
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(note),
            }}
          />
        </StNotes>
      ))}
    </FlexColumn>
  ) : null
}

export { EncounterNotes }
